import {
    AfterViewInit,
    Component,
    NgZone,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core'
import { Router } from '@angular/router'
import { PrimeNGConfig } from 'primeng/api'
import { AuthService, UserService } from './api/services'
import { AppComponent } from './app.component'
import { CareFinitySession } from './carefinity/services/CareFinitySession'
import {
    SessionTimeOutEventArgs,
    SessionTimeOutEventType,
    SessionTimeOutService,
} from './carefinity/services/SessionTimeOutService'
import { MenuService } from './carefinity/views/shared-components/app.menu.service'
import {
    MessageType,
    SignalRService,
} from './carefinity/services/SignalRService'
import { ErrorPopupComponent } from './carefinity/popups/errorpopup.component'
import { ErrorService } from './carefinity/services/ErrorService'
import { AppSettingService } from './api/services'
import { Subject, Subscription, takeUntil, tap } from 'rxjs'
@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    providers: [SessionTimeOutService],
})
export class AppMainComponent implements AfterViewInit, OnInit, OnDestroy {
    topbarMenuActive: boolean

    menuActive: boolean

    staticMenuDesktopInactive: boolean

    mobileMenuActive: boolean

    menuClick: boolean

    mobileTopbarActive: boolean

    topbarRightClick: boolean

    topbarItemClick: boolean

    activeTopbarItem: string

    documentClickListener: () => void

    configActive: boolean

    configClick: boolean

    rightMenuActive: boolean

    menuHoverActive = false

    searchClick = false

    search = false

    currentInlineMenuKey: string

    inlineMenuActive: any[] = []

    inlineMenuClick: boolean
    loggedInUserName: string = CareFinitySession.user.name
    countDownSubscription: Subscription
    messageSubscription: Subscription
    destroy = new Subject<void>()

    get isLoggedIn() {
        return CareFinitySession.isActive
    }

    showSessionPopup = false

    constructor(
        public renderer: Renderer2,
        private router: Router,
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        private sessionTimer: SessionTimeOutService,
        private userService: UserService,
        private authService: AuthService,
        private zone: NgZone,
        private _server: SignalRService,
        private errorService: ErrorService,
        private appSettingService: AppSettingService,
    ) { }

    ngOnInit() {
        this.menuActive = this.isStatic() && !this.isMobile()

        this.appSettingService
            .appSettingGetApplicationSettings$Response()
            .subscribe({
                next: (setings) => {
                    CareFinitySession.loadAppSettings(setings.body)
                    this.setSessionTimer()
                },
                error: (err) => {
                    console.error(err)
                },
            })
    }

    @ViewChild('errorPopup') errorPopup: ErrorPopupComponent

    ngAfterViewInit() {
        this.errorService.error$.subscribe((message) => {
            this.app.closeAnyErros()
            this.errorPopup.show(message)
        })

        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', () => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null
                this.topbarMenuActive = false
            }

            if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
                this.menuService.reset()
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false
            }

            if (!this.menuClick) {
                if (this.mobileMenuActive) {
                    this.mobileMenuActive = false
                }

                if (this.isOverlay()) {
                    this.menuActive = false
                }

                this.menuHoverActive = false
                this.unblockBodyScroll()
            }

            if (!this.searchClick) {
                this.search = false
            }

            if (
                this.inlineMenuActive[this.currentInlineMenuKey] &&
                !this.inlineMenuClick
            ) {
                this.inlineMenuActive[this.currentInlineMenuKey] = false
            }

            this.inlineMenuClick = false
            this.searchClick = false
            this.configClick = false
            this.topbarItemClick = false
            this.topbarRightClick = false
            this.menuClick = false
        })
    }

    private setSessionTimer() {
        this.sessionTimer.timeOut
            .pipe(
                takeUntil(this.destroy),
            )
            .subscribe((event: SessionTimeOutEventArgs) => {
                this.sessionAboutToTimeOut(event)
            })

        this.sessionTimer.countDown
            .pipe(
                takeUntil(this.destroy),
            )
            .subscribe((event: SessionTimeOutEventArgs) => {
                this.sessionTimedOut(event)
            })
        this.sessionTimer.initilizeSessionTimeout()
        this._server.startConnection('MessageServer')
        this._server.message$.pipe(takeUntil(this.destroy)).subscribe((message) => {
            if (
                message.type === MessageType.EndSession &&
                message.payload == CareFinitySession.sessionID
            ) {
                this.sessionTimer.stopIdleTimer()
                this.sessionTimer.stopWarningTimer()
                this._server.stop()
                this.router.navigate(['sesssionEnded'], { state: { end: true } })
            }
        })
    }

    onMenuButtonClick(event) {
        this.menuActive = !this.menuActive
        this.topbarMenuActive = false
        this.topbarRightClick = true
        this.menuClick = true

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive
        } else {
            this.mobileMenuActive = !this.mobileMenuActive
            if (this.mobileMenuActive) {
                this.blockBodyScroll()
            } else {
                this.unblockBodyScroll()
            }
        }

        event.preventDefault()
    }

    onTopbarMobileButtonClick(event) {
        this.mobileTopbarActive = !this.mobileTopbarActive
        event.preventDefault()
    }

    onRightMenuButtonClick(event) {
        this.rightMenuActive = !this.rightMenuActive
        event.preventDefault()
    }

    onMenuClick($event) {
        this.menuClick = true

        if (
            this.inlineMenuActive[this.currentInlineMenuKey] &&
            !this.inlineMenuClick
        ) {
            this.inlineMenuActive[this.currentInlineMenuKey] = false
        }
    }

    onSearchKeydown(event) {
        if (event.keyCode == 27) {
            this.search = false
        }
    }

    onInlineMenuClick(event, key) {
        if (key !== this.currentInlineMenuKey) {
            this.inlineMenuActive[this.currentInlineMenuKey] = false
        }

        this.inlineMenuActive[key] = !this.inlineMenuActive[key]
        this.currentInlineMenuKey = key
        this.inlineMenuClick = true
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null
        } else {
            this.activeTopbarItem = item
        }

        if (item === 'search') {
            this.search = !this.search
            this.searchClick = !this.searchClick
        }

        event.preventDefault()
    }

    onTopbarSubItemClick(event) {
        event.preventDefault()
    }

    onRTLChange(event) {
        this.app.isRTL = event.checked
    }

    onRippleChange(event) {
        this.app.ripple = event.checked
        this.primengConfig.ripple = event.checked
    }

    onConfigClick(event) {
        this.configClick = true
    }

    isDesktop() {
        return window.innerWidth > 991
    }

    isMobile() {
        return window.innerWidth <= 991
    }

    isOverlay() {
        return this.app.menuMode === 'overlay'
    }

    isStatic() {
        return this.app.menuMode === 'static'
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal'
    }

    isSlim() {
        return this.app.menuMode === 'slim'
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll')
        } else {
            document.body.className += ' blocked-scroll'
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll')
        } else {
            document.body.className = document.body.className.replace(
                new RegExp(
                    '(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)',
                    'gi',
                ),
                ' ',
            )
        }
    }
    secondTimerLeft = ''
    sessionAboutToTimeOut = (e: SessionTimeOutEventArgs) => {
        switch (e.eventType) {
            case SessionTimeOutEventType.TimerCompleted:
                this.showSessionTimeOutPopup()
                break
            case SessionTimeOutEventType.TimerTick:
                this.sendHeartBeat()
                break
        }
    }

    sessionTimedOut = (e: SessionTimeOutEventArgs) => {
        switch (e.eventType) {
            case SessionTimeOutEventType.TimerCompleted:
                this.logout()

                break
            case SessionTimeOutEventType.TimerTick:
                this.secondTimerLeft = e.args
                break
        }
    }

    showSessionTimeOutPopup(): void {
        this.showSessionPopup = true
    }

    logout(): void {
        try {
            this.showSessionPopup = true
            this.sessionTimer.stopIdleTimer()
            this.sessionTimer.stopWarningTimer()
            this._server.stop()
            console.log('app.main.logout')
            CareFinitySession.logout(this.authService)
        } catch (err) {
            console.error(err)
        }
        this.router.navigate(['sesssionTimeout'])
    }

    heartBeatCounter = 0
    sendHeartBeat() {
        if (CareFinitySession.isActive) {
            if (this.heartBeatCounter > 30) {
                //this.userService.userEcho({
                //    sessionID: CareFinitySession.sessionID
                //}).subscribe(
                this.userService.userEcho().subscribe({
                    next: (res) => { },
                    error: (err) => {
                        if (err.status == 401 || err.status == 403) {
                            console.log('app.main.sendHeartBeat.logout')
                            CareFinitySession.logout(this.authService)
                        }
                    },
                })
                this.heartBeatCounter = 0
            }
            this.heartBeatCounter++
        }
    }

    continueSession(): void {
        this.showSessionPopup = false
        this.sessionTimer.stopWarningTimer()
        this.sessionTimer.initilizeSessionTimeout()
    }

    ngOnDestroy() {
        console.log('app.main.ngOnDestroy')

        if (this.documentClickListener) {
            this.documentClickListener()
        }

        this.destroy.next()

        this.sessionTimer.stopIdleTimer()

        this.sessionTimer.stopWarningTimer()
        this._server.stop()
    }
}
